module.exports = __webpack_public_path__ + "static/media/digital-tachograph.779cd631.svg";